import React from 'react';
import { Zap, Brain, Flame, TrendingUp } from 'lucide-react';
import { mockData } from '../mock';

const PowerFeatures = () => {
  const iconMap = {
    Zap,
    Brain,
    Flame,
    TrendingUp
  };

  return (
    <section className="py-20 bg-jet-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-electric-blue/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-neon-green/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="heading-power mb-6 animate-slide-power">
            WHY IT <span className="text-electric-blue">WORKS</span>
          </h2>
          <p className="text-energy max-w-3xl mx-auto animate-slide-power delay-200">
            Our AI doesn't just give advice - it TRANSFORMS you with cutting-edge technology 
            that adapts, motivates, and delivers real results.
          </p>
        </div>

        {/* Power Feature Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockData.powerFeatures.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            
            return (
              <div 
                key={feature.id}
                className="group text-center animate-slide-power hover-lift"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Power Icon Container */}
                <div className="relative mb-8">
                  {/* Glow Background */}
                  <div className="absolute inset-0 bg-gradient-primary rounded-full blur-xl opacity-50 group-hover:opacity-100 transition-opacity duration-300 scale-150"></div>
                  
                  {/* Icon Container */}
                  <div className="relative w-24 h-24 mx-auto bg-gradient-to-br from-gray-900 to-black rounded-full flex items-center justify-center neon-border group-hover:neon-border-blue transition-all duration-300">
                    <Icon className="w-12 h-12 text-white group-hover:text-neon-green transition-colors duration-300" />
                  </div>
                  
                  {/* Subtle Energy Rings */}
                  <div className="absolute inset-0 border border-electric-blue/10 rounded-full animate-pulse opacity-50" style={{animationDuration: '3s'}}></div>
                </div>
                
                {/* Feature Content */}
                <h3 className="heading-bold text-white mb-4 group-hover:text-neon-green transition-colors duration-300">
                  {feature.title}
                </h3>
                
                <p className="text-standard text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors duration-300">
                  {feature.description}
                </p>

                {/* Power Bar Indicator */}
                <div className="w-16 h-1 bg-gray-800 mx-auto mt-6 rounded-full overflow-hidden">
                  <div className="w-0 h-full bg-gradient-primary group-hover:w-full transition-all duration-500 rounded-full"></div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom Power Statement */}
        <div className="text-center mt-20 animate-slide-power delay-500">
          <div className="inline-block bg-gradient-to-r from-electric-blue/20 to-neon-green/20 rounded-2xl p-8 neon-border">
            <h3 className="heading-bold text-white mb-4">
              NO EXCUSES. NO LIMITS. JUST <span className="text-neon-green">RESULTS</span>.
            </h3>
            <p className="text-energy max-w-2xl">
              Join the revolution of people who stopped settling for average and started living at their peak potential.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PowerFeatures;